import React from 'react';

const PublishingOverlay = () => {
  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-orange-500 mb-4"></div>
      <h2 className="text-xl font-semibold text-gray-800 mb-2">Publishing Report</h2>
      <p className="text-gray-600">Please wait while we generate and upload your report...</p>
    </div>
  );
};

export default PublishingOverlay; 